// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_DesabilitausuarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for desabilitaUsuario() /usuarios/desabilitaUsuario
 * Returns bool (true) on successful user disable via auth-service.
 * Proxy to auth-service /user/desabilitaUsuario/{username}.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_DesabilitausuarioResponseDados = boolean;

export type Usuarios_DesabilitausuarioResponse = ApiResponse<Usuarios_DesabilitausuarioResponseDados>;

registerResponseContract('Usuarios_DesabilitausuarioResponse', {})
